import useGet from "../read/useGet";

const useDriverTripLogs = (trip_id, company_employee_id) => {

    const initialParams = {
        trip_id,
        company_employee_id
    }

    const {
        list: tripLogsData,
        isLoading,
        paramsObject,
        setGetListParams
    } = useGet({
        url: "trip/fetch_driver_trips_logs",
        method: "get",
        initialData: initialParams,
    });

    return {
        tripLogsData: tripLogsData?.data,
        isLoading,
        paramsObject,
        setGetListParams
    }
};

export default useDriverTripLogs;
